<template>
  <component :is="component" v-if="component" :infoData="infoData" ></component>
</template>

<script>
export default {
  name: "ImageLink",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    listLayout: '',
    infoData: {
      type: Object,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      component: null
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader();
        })
        .catch(() => {
          this.component = () => import('@/template/information/ImageDefaultLayout');
        })
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.listLayout) {
        return null;
      }
      return () => import(`@/template/information/${this.listLayout}`)
    }
  },
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>